import { Checkbox } from "@mantine/core";
import CheckboxSurvey from "../../../components/form/Checkbox";
import { useTranslation } from "react-i18next";
import { TIdentifiedReportChannel } from "../../../types";

type Props = {
  form: any;
  channels: TIdentifiedReportChannel[];
};

const Component = ({ form, channels }: Props) => {
  const { t } = useTranslation();

  return (
    <CheckboxSurvey
      label={t("harassmentReportChannels.label")}
      {...form.getInputProps("SP_004_011_canalesDeDenuncias")}
    >
      {channels.map((channel) => (
        <Checkbox
          key={channel.id}
          label={`${channel.description}.`}
          value={String(channel.id)}
        />
      ))}
    </CheckboxSurvey>
  );
};

export default Component;
